import React, { useEffect } from 'react';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../Button';
import BackArrowsvg from './../../../assets/svg/LeftArrow.svg';
import './SelectionModal.css';
import DynamicSearchBar from '../SearchBar';
import CheckboxComponent from '../CheckBox';
import CrossSVG from './../../../assets/svg_main/CrossIcon.svg'


interface SelectionProps {
    items: { [key: string]: string };
    onSave: (selectedItems: { [key: string]: string },flag:boolean, selectedItemsDetails:any) => void;
    searchPlaceholder: string;
    title: string;
    details:{ [key: string]: string };
    selectedItemsProps:{ [key: string]: string };
}

const SelectionModal: React.FC<SelectionProps> = ({ items, onSave, searchPlaceholder, title, details, selectedItemsProps}) => {
  
    const [selectedItems, setSelectedItems] = useState<{ [key: string]: string }>(selectedItemsProps);
    const [selectedAll, setSelectedAll] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState('');
    
    
    
    
    // useEffect(() => {
    //     setSelectedItems(items);
    // }, [items]);
    
    useEffect(() => {
        if (Object.keys(selectedItemsProps).length > 0) {
            setSelectedItems(selectedItemsProps);
        }
    }, [selectedItemsProps]);


    const handleSelectAll = (SelectAllStatus :boolean) =>{
        // setSelectedAll(!SelectAllStatus);
        if(Object.keys(selectedItems)?.length < Object.keys(items)?.length)
        {
         SelectAllStatus = false;
        }
        if(Object.keys(selectedItems)?.length === Object.keys(items)?.length)
        {
            SelectAllStatus = true;
        }
        
        if(!SelectAllStatus){
           setSelectedItems(items);
        } else {
            setSelectedItems({});
        }



    }


    const handleCheckboxChange = (key: string) => {
        if (selectedItems[key]) {
            const { [key]: _, ...rest } = selectedItems;
            setSelectedItems(rest);
        } else {
            setSelectedItems({ ...selectedItems, [key]: items[key] });
        }
    };

    const handleRemoveItem = (key: string) => {
        const { [key]: _, ...rest } = selectedItems;
        setSelectedItems(rest);
        
    };

    const handleSave = () => {
        if (Object.keys(selectedItems).length === 0) {
            onSave({}, false, []);
        }
        else{
            const selectedItemsDetails = Object.keys(selectedItems).map((key) => {
          const itemDetails = details[key] as {
            village_name?:string;
            village_id?: string;
            village_code?: string;
            gram_panchayat_name?:string;
            gram_panchayat_id?: string;
            gram_panchayat_code?: string;
            ward_name?:string;
            ward_id?: string;
            ward_code?: string;
            facility_name?: string;
            facility_id?: string;
            facility_code?: string;
          };
      
          if (itemDetails?.village_id) {
            return {
              name: itemDetails?.village_name,
              id: itemDetails?.village_id,
              code: itemDetails?.village_code,
            };
          } 
          else if (itemDetails?.gram_panchayat_id) {
            return {
              name: itemDetails?.gram_panchayat_name,
              id: itemDetails?.gram_panchayat_id,
              code: itemDetails?.gram_panchayat_code,
            };
          } else if (itemDetails?.ward_id) {
            return {
              name: itemDetails?.ward_name,
              id: itemDetails?.ward_id,
              code: itemDetails?.ward_code,
            };
          } else if (itemDetails?.facility_id) {
            return {
              name: itemDetails?.facility_name,
              id: itemDetails?.facility_id,
              code: itemDetails?.facility_code,
            };
          }
          return null;
            }).filter((item) => item !== null);
            onSave(selectedItems, false, selectedItemsDetails);
        }   
      };

    const [show, setShow] = useState<boolean>(true);
    const handleClose = (): void => {
        // onSave({},false,[]);
        setShow(false);
    };
    const handlePrevious = (): void => {
        onSave(selectedItemsProps,false,[]);
       // setShow(false);
    };
    const handleSearchChange = (value: string) => {
        setSearchTerm(value?.toLowerCase());
    };
    const filteredItems = Object.entries(items).filter(([key, name]) =>
        name?.toLowerCase().includes(searchTerm)
    );
    const onCancel=():void=>{
        onSave(selectedItemsProps,false,[]);
        //setShow(false);
    }
    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                dialogClassName="custom_modal_page_selection"
            >
                <Modal.Body className="pade_modal_body">
                    <div className="selection-modal-main">
                        <div className="selection-container-modal">
                            <div className="selection_modal_left">
                                <DynamicSearchBar
                                    onChange={handleSearchChange}
                                    placeHolder={searchPlaceholder}
                                    disabled={false}
                                    className=""
                                    iconNeeded={true} />
                                <div className='selection_modal_left_checkbox_label'>
                                <div className='selection_modal_checkbox_label' key={'o'}>
                                            <div>
                                            <CheckboxComponent
                                                    className=""
                                                    isChecked={false}
                                                    disabled={false}
                                                    onCheckboxChange={() => handleSelectAll(selectedAll)}
                                                    placeCheckboxBefore={false}
                                                />                
                                            </div>
                                            <div>
                                                <label className='selection_modal_label_names'>{`${Object.keys(selectedItems)?.length === Object.keys(items)?.length ? 'Deselect All' : 'Select All'}`}</label>
                                            </div>
                                </div>
                                    {filteredItems.map(([key, name]) => (
                                        <div className='selection_modal_checkbox_label' key={key}>
                                            <div>
                                                <CheckboxComponent
                                                    className=""
                                                    isChecked={!!selectedItems[key]}
                                                    disabled={false}
                                                    onCheckboxChange={() => handleCheckboxChange(key)}
                                                    placeCheckboxBefore={false}
                                                />
                                            </div>
                                            <div>
                                                <label className='selection_modal_label_names'>{name}</label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="selection_modal_right">
                                <span className='selection_modal_right_title'>{title} <span style={{color:'#5f5f5f', fontSize:'10px'}}>{`(${Object.keys(selectedItems)?.length} of ${Object.keys(items)?.length} selected)`}</span></span>
                                <div className="selected_modal_grid">
                                    {Object.entries(selectedItems).map(([key, name]) => (
                                        <div key={key} className="selected_grid_item" title={name}>
                                            <span className='selection_modal_right_name'>{name}</span>
                                            <Button
                                                onClick={() => handleRemoveItem(key)}
                                                disabled={false}
                                                id=""
                                                buttonName={''}
                                                colorType={'previous'}
                                                icon={<CrossSVG />}
                                                iconPosition={'right'}
                                            />

                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="page_modal_footer">
                    <Button
                        onClick={handlePrevious}
                        disabled={false}
                        id=""
                        buttonName={'previous'}
                        colorType={'previous'}
                        icon={<BackArrowsvg />}
                        iconPosition={'left'}
                    />
                    <div className="page_modal_footer_buttons">
                        <Button
                            onClick={onCancel}
                            disabled={false}
                            id=""
                            buttonName={'Cancel'}
                            colorType={'save'}
                            icon={''}
                            iconPosition={''}
                        />
                        <Button
                            onClick={handleSave}
                            disabled={false}
                            id=""
                            buttonName={'Save'}
                            colorType={'primary'}
                            icon={''}
                            iconPosition={''}
                        />
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SelectionModal;
